'use strict'

import Utils from './../common/utils'
import moment from 'moment'

export default class Site {
    // constructor() {

    // }

    static fromData(data) {
        if (!data) {
            return null
        }
        let site = new Site()
        site._id = Utils.isNumber(data.site_id) ? data.site_id : -1
        site._section_id = data.section_id || null
        site._site_id = data.site_id || null
        site._name = data.site_name || null
        site._km = data.site_km || -1
        site._lat = data.site_lat || 0
        site._lon = data.site_lon || 0
        site._city = data.site_city || null
        site._state = data.site_state || null
        site._tracked_km = data.site_tracked_km || 0
        site._rtu_timestamp = data.rtu_timestamp || null
        site._pressure = Utils.isNumber(data.rtu_pressure) ? data.rtu_pressure : null
        site._flow = Utils.isNumber(data.rtu_flow) ? data.rtu_flow : null
        site._battery = Utils.isNumber(data.rtu_battery) ? data.rtu_battery : null
        site._site_door = Utils.isNumber(data.rtu_site_door) ? data.rtu_site_door : null
        site._cabinet_door = Utils.isNumber(data.rtu_cabinet_door) ? data.rtu_cabinet_door : null
        site._leak = Utils.isNumber(data.rtu_leak) ? data.rtu_leak : null
        site._gps = Utils.isNumber(data.rtu_gps) ? data.rtu_gps : null
        site._rtu_formated_date = data.formated_date || null
        site._online = data.online || 0
        site._insert_timestamp = data.insert_timestamp || 'N/A'
        site._comm_online = data.comm_online || 0
        site._enabled = data.enabled || 0
        // "rtu_timestamp":"2017-11-23T04:46:03.000Z","rtu_pressure":8.87,"rtu_flow":0,"rtu_battery":13,"rtu_site_door":1,"rtu_cabinet_door":0,"rtu_leak":0,"rtu_gps":1,"formated_date":"2017-11-22 22:46:03"
        return site
    }

    get id () {
        return this._id
    }

    get name () {
        return this._name
    }

    get km () {
        return this._km
    }

    get lat () {
        return this._lat
    }

    get lon () {
        return this._lon
    }

    get formattedCoord() {
        return `${this._lat}, ${this._lon}`
    }

    get city () {
        return this._city
    }

    get state () {
        return this._state
    }

    get trackedKm () {
        return this._tracked_km
    }

    get rtuTimestamp () {
        return this._rtu_timestamp
    }

    get pressure () {
        return this._pressure
    }

    get flow () {
        return this._flow
    }

    get battery () {
        return this._battery
    }

    get siteDoor () {
        return this._site_door
    }

    get cabinetDoor () {
        return this._cabinet_door
    }

    get leak () {
        return this._leak
    }

    set leak (val) {
      this._leak = val
    }

    get gps () {
        return this._gps
    }

    get rtuFormatedDate () {
        return this._rtu_formated_date
    }

    get online () {
        return this._online
    }

    get insertTimestamp () {
        return this._insert_timestamp
    }

    get comm_online () {
        return this._comm_online
    }

    get enabled () {
        return this._enabled
    }

    get section_id () {
        return this._section_id
    }    

    get site_id () {
        return this._site_id
    }    

    hasData() {
        return this._rtu_timestamp !== null && this._pressure !== null && this._flow !== null &&
            this._battery !== null && this._site_door !== null && this._cabinet_door !== null &&
            this._leak !== null && this._gps !== null && this._rtu_formated_date !== null &&
            this._online !== null && this._comm_online !== null && this._enabled !== null
    }

    hasFailure () {
        return !this.hasData() || (this._site_door === 1 || this._cabinet_door === 1 || this._gps === 0 || this._online === 0)
    }

    hasPressueAlarm () {
        return this._pressure && Number(this._pressure) <= 2;
    }

    isOffline () {
        return !this._online || !this._rtu_timestamp || !moment(this._rtu_formated_date).isValid()
    }



    static _hasData(site) {
        return site._rtu_timestamp !== null && site._pressure !== null && site._flow !== null &&
            site._battery !== null && site._site_door !== null && site._cabinet_door !== null &&
            site._leak !== null && site._gps !== null && site._rtu_formated_date !== null &&
            site._online !== null && site._comm_online !== null && site._enabled !== null
    }

    static _hasFailure (site) {
        return !Site._hasData(site) || (site._site_door === 1 || site._cabinet_door === 1 || site._gps === 0 || site._online === 0)
    }

    static _hasPressureAlarm (site) {
        return site._pressure && Number(site._pressure) <= 2;
    }

    static _isOffline (site) {
        return !site._online || !site._rtu_timestamp || !moment(site._rtu_formated_date).isValid()
    }

}



// WEBPACK FOOTER //
// ./src/models/site.js